import { Injectable, inject } from '@angular/core';
import { GalleryDto } from '@nusign/picflow-backend-types';
import { PICFLOW_CONFIG } from '../picflow-config';
import { StorageService } from './storage.service';

export interface NewGalleryEmbedOptions {
  lightbox: boolean;
  lightboxColor: string;
  allowDownloads: boolean;
  rightClickProtection: boolean;
  noPadding: boolean;
  noBackground: boolean;
  showCover: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class GalleryEmbedService {
  private storage = inject(StorageService);
  private config = inject(PICFLOW_CONFIG);

  getNewEmbedCode(gallery: GalleryDto, options: NewGalleryEmbedOptions) {
    let optionsString = '';

    if (options.lightbox) {
      optionsString += ` lightbox="${options.lightboxColor}"`;

      if (options.allowDownloads) {
        optionsString += ' downloads="true"';
      }
    }

    if (options.rightClickProtection) {
      optionsString += ' protection="true"';
    }

    if (options.noPadding) {
      optionsString += ' no-padding="true"';
    }

    if (options.noBackground) {
      optionsString += ' no-background="true"';
    }
    if (options.showCover) {
      optionsString += ' show-cover="true"';
    }

    return `<script>if(!window.picflow){window.picflow=!0;var s=document.createElement("script");s.src="${this.config.correctPicflowUrl}/embed/main.js";s.type='module';s.defer=true;document.head.appendChild(s);}</script><picflow-gallery id="${gallery.id}"${optionsString}></picflow-gallery>`;
  }

  public getNewEmbedPreferences(): NewGalleryEmbedOptions {
    const storedOptions = this.storage.get('newEmbedPreferences');
    if (storedOptions) return storedOptions;
    return {
      lightbox: true,
      lightboxColor: '#000000E6',
      allowDownloads: false,
      rightClickProtection: false,
      noPadding: false,
      noBackground: false,
      showCover: false,
    };
  }

  public setNewEmbedPreferences(options: NewGalleryEmbedOptions): void {
    this.storage.set('newEmbedPreferences', options);
  }
}
